import React from 'react';
import { Box, Typography, Stack, TextField } from '@mui/material';

interface PolicyInfoSectionProps {
  policyNumber: string;
  groupNumber: string;
  groupName: string;
  onInputChange: (field: 'policyNumber' | 'groupNumber' | 'groupName', value: string) => void;
}

export const PolicyInfoSection: React.FC<PolicyInfoSectionProps> = ({
  policyNumber,
  groupNumber,
  groupName,
  onInputChange,
}) => (
  <Box>
    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
      Policy Information
    </Typography>
    <Stack spacing={2}>
      <Stack direction="row" spacing={2}>
        <TextField
          label="Policy Number"
          size="small"
          value={policyNumber}
          onChange={(e) => onInputChange('policyNumber', e.target.value)}
          sx={{ flex: 1 }}
          required
        />
        <TextField
          label="Group Number"
          size="small"
          value={groupNumber}
          onChange={(e) => onInputChange('groupNumber', e.target.value)}
          sx={{ flex: 1 }}
        />
        <TextField
          label="Group Name"
          size="small"
          value={groupName}
          onChange={(e) => onInputChange('groupName', e.target.value)}
          sx={{ flex: 1 }}
        />
      </Stack>
    </Stack>
  </Box>
);
